import { api } from '@/services';
import { turboproFetch } from '@/api/turbopro';
import type { ApiResponse } from '@/api/envelope';
import type { FiltroApontamentosIbsCbs, RelatorioApontamentosIbsCbsResponse } from '../types';

/**
 * O relatório "Entradas — apontamentos das regras de IBS e CBS" (SPEC-008), servido pelo módulo da Reforma
 * (`TurboPro/RelatorioApontamentosIbsCbs`) — não pelo catálogo comum da Central (SPEC-015, decisão 10).
 */
const BASE = 'TurboPro/RelatorioApontamentosIbsCbs';

export function consultaDoFiltro(filtro: FiltroApontamentosIbsCbs): string {
  const parametros = new URLSearchParams({
    competenciaInicial: filtro.competenciaInicial,
    competenciaFinal: filtro.competenciaFinal,
    cnpjContribuinte: filtro.cnpjContribuinte.replace(/\D/g, ''),
  });
  return parametros.toString();
}

export const fetchRelatorioApontamentosIbsCbs = (filtro: FiltroApontamentosIbsCbs) =>
  api.get<RelatorioApontamentosIbsCbsResponse>(`${BASE}/Dados?${consultaDoFiltro(filtro)}`);

export type FormatoDoArquivo = 'Pdf' | 'Csv';

/**
 * Baixa o PDF ou o CSV. O arquivo vem direto no corpo; parâmetro recusado volta no envelope JSON de sempre
 * (HTTP 200 com `status.resultado = false`), e é pelo tipo do conteúdo que se distingue um do outro.
 */
export async function baixarRelatorioApontamentosIbsCbs(
  filtro: FiltroApontamentosIbsCbs,
  formato: FormatoDoArquivo
): Promise<{ arquivo: Blob; nome: string }> {
  const resposta = await turboproFetch(`${BASE}/${formato}?${consultaDoFiltro(filtro)}`, {
    timeoutMs: 120000,
  });
  const tipo = resposta.headers.get('Content-Type') ?? '';

  if (!resposta.ok || tipo.includes('application/json')) {
    let mensagem = 'Não foi possível gerar o arquivo.';
    try {
      const corpo = (await resposta.json()) as ApiResponse<unknown>;
      mensagem = corpo?.status?.mensagem || mensagem;
    } catch {
      /* corpo não-JSON: segue com a mensagem padrão */
    }
    throw new Error(mensagem);
  }

  const extensao = formato === 'Pdf' ? 'pdf' : 'csv';
  return {
    arquivo: await resposta.blob(),
    nome: `entradas-apontamentos-ibs-cbs_${filtro.competenciaInicial}_${filtro.competenciaFinal}.${extensao}`,
  };
}
